import { __module as i } from "./chunk675.js";
import { __require as u } from "./chunk447.js";
import { __require as d } from "./chunk464.js";
var f = i.exports, t;
function q() {
  return t ? i.exports : (t = 1, function(a, p) {
    (function(e, r, o) {
      a.exports = r(u(), d());
    })(f, function(e) {
      return e.pad.Iso10126 = {
        pad: function(r, o) {
          var s = o * 4, n = s - r.sigBytes % s;
          r.concat(e.lib.WordArray.random(n - 1)).concat(e.lib.WordArray.create([n << 24], 1));
        },
        unpad: function(r) {
          var o = r.words[r.sigBytes - 1 >>> 2] & 255;
          r.sigBytes -= o;
        }
      }, e.pad.Iso10126;
    });
  }(i), i.exports);
}
export {
  q as __require
};
